import React, { Component } from 'react';
import { withRouter } from 'react-router-dom' 
import InputWithExtra from '../../Comman/components/InputWithExtra';
//import Popup from 'reactjs-popup'
import Modal from 'react-responsive-modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TwitterPicker ,ChromePicker,  } from 'react-color';
import 'primereact/resources/primereact.min.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {InputText} from 'primereact/inputtext';
import SimpleReactValidator from 'simple-react-validator';
import noimage from '../../Comman/images/no_image.png';
import loader from '../../Comman/images/loader.gif'
//import {Dropdown} from 'primereact/dropdown';
import {baseUrl} from '../../Comman/apiEndPoints'
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';

var OptionsCounter=1;
var EmojiCounter=1;
// var emojiOptions=[];
var svValidator;
var engValidator;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
const url=process.env.REACT_APP_SET_URL;
const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

class FeedbackSettingAddComponent extends Component {
    toastId = null;
    constructor(props) {
        super(props);
        
        this.state = {
            feedbackSettings: {
                QuestionTypeId: "1" ,
                QuestionText:'' ,
                FeedbackTypeId : '1'
            },
            isLoader : false 
        };
        this.handleInput = this.handleInput.bind(this);     
        this.apendNode = this.apendNode.bind(this);      
        this.notify=this.notify.bind(this); 
        this.baseState=this.state;
    }
 
    componentWillMount() { 
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale : 'en'
            }
          ); 
          svValidator = new SimpleReactValidator(
            {
                locale : 'sv'
            }
          ); 
          this.validator = engValidator;
      }

    componentWillReceiveProps(nextProps) { 
        console.log("next",nextProps);
        if (nextProps.feedbackSettings !== this.props.feedbackSettings) { 
            if(nextProps.statusCode==200){
                    this.notify(nextProps.feedbackSettings.messageLabel) 
                    this.validator.hideMessages();
                    this.setState({
                        feedbackSettings: {
                            QuestionTypeId: "1" ,
                            QuestionText:'' ,
                            FeedbackTypeId : '1'
                        } 
                     })
            }
            if(nextProps.statusCode==201){
                this.errornotify(nextProps.feedbackSettings.messageLabel)
            }
        }
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }

    handleInput(e) {   
       let value = e.target.value;
       let name = e.target.name; 
       this.setState( prevState => ({ feedbackSettings : 
        {...prevState.feedbackSettings, [name]: value}
      }),  )  
    }

    errornotify = (message) => { 
        swal({text : message, icon : 'error'})
        this.setState({isLoader : false})
        // this.toastId =toast.error(message, {
        //   position: toast.POSITION.TOP_CENTER
        // });  
      }

     
      insertQuestionDetailsSettings() {
        const { t } = this.props;
        this.setState({isLoader : true})
        if (this.validator.allValid()) {  
            let feedbackSettings = this.state.feedbackSettings;   
             var formData={};
            if(feedbackSettings.QuestionTypeId == ''){
                this.setState( prevState => ({
                    notificationSettings : 
                    {...prevState.feedbackSettings,
                        QuestionTypeId: document.getElementById("questionTypeDD").value, 
                    }  
                  })) 
            } 
            sleep(1000).then(() => {  
                feedbackSettings = this.state.feedbackSettings;    
               formData.QuestionTypeId=feedbackSettings.QuestionTypeId;
               formData.QuestionText=feedbackSettings.QuestionText;
               formData.FeedbackTypeId=feedbackSettings.FeedbackTypeId;
               if(feedbackSettings.QuestionTypeId == "2"){
                   let allInputs = document.getElementById('mcqOptions').getElementsByTagName('input');
                   for(var i=0; i < allInputs.length; i++) {
                        if(allInputs[i].value == '' || allInputs[i].value == undefined){
                            allInputs[i].style.border="1px solid #F00"; 
                            swal(`${t('Feedback Setting.Please enter value')}`);
                            this.setState({isLoader : false})
                            allInputs[i].onclick=function(){ this.style.border="2px solid #CCC"; }
                            return;
                        }
                    }
                var ansArray=[];
                   for(var optionCount=1;optionCount<=OptionsCounter;optionCount++){ 
                    var ansObj={};
                    if(document.getElementById("mcqOptionText"+optionCount)){
                        ansObj.Option = document.getElementById("mcqOptionText"+optionCount).value;
                    }
                    else{
                        continue;
                    }
                    ansArray.push(ansObj);
                   }
                   formData.AnswerList=ansArray;
            }
           else if(feedbackSettings.QuestionTypeId == "3"){
            let inputEle = document.getElementById('emoji_option').getElementsByTagName('input');
            for(var item of inputEle) {
                 if(item && (item.value == '' || item.value == undefined)){
                    item.style.border="1px solid #F00"; 
                    swal(`${t('Feedback Setting.Please enter value')}`);
                    this.setState({isLoader : false})
                    item.onclick=function(){ this.style.border="2px solid #CCC"; }
                    return;
                 }
             }

            let divEle = document.getElementById('emoji_option').getElementsByTagName('div');
            for(var i = 0; i < divEle.length; i++) {
                var id = divEle[i].id.split('_');
                var myChecked = 0;
                var radioEle = document.getElementsByName(`EmojiImage${id[1]}`);
                for(var j=0; j < radioEle.length; j++){
                    if (myChecked == 1) {
                        continue;                	
                    } 
                    if (radioEle[j].checked)  {
                        myChecked = 1;	
                    }        
                } 
                if(myChecked !== 1){
                    swal(`${t('Feedback Setting.Choose one emoji')}`);
                    this.setState({isLoader : false});
                    return;
                }          
            }
            var ansArray=[];
            for(var optionCount=1;optionCount<=EmojiCounter;optionCount++){ 
             var ansObj={};
             if(document.getElementById("emojiOptionText"+optionCount)){
                ansObj.Option = document.getElementById("emojiOptionText"+optionCount).value;
             }
             else{
                 continue;
             }
             var ele=document.getElementsByName("EmojiImage"+optionCount);
             for(var i = 0; i < ele.length; i++) { 
                if(ele[i].checked) 
                ansObj.OptionEmoji = ele[i].value; 
            }  
             ansArray.push(ansObj);
            }
            formData.AnswerList=ansArray; 
            }
            console.log(formData)
            this.props.insertQuestionDetailsSettings(formData);
            }) 
        }else {
            this.validator.showMessages(); 
            this.forceUpdate();
            this.setState({isLoader : false})
        }
        
    } 

    handleError=()=>{
        this.setState({
            rowimage:noimage
         });
    }
 

     notify = (message) => {  
        swal({text : message, icon : 'success'})
        this.setState({isLoader : false})
    //   this.toastId =toast.success(message, {
    //     position: toast.POSITION.TOP_CENTER
    //   });  
    } 
  
      
    createOptionsTextbox(){
        const { t } = this.props;
        OptionsCounter=OptionsCounter+1;
        var input = document.createElement('input');
        input.type = 'text';
        input.setAttribute("class","formControl1 option_text");
        input.id='mcqOptionText'+OptionsCounter;
        input.name = 'mcqOptionText'+OptionsCounter;
        input.title= "mcqOptionText"+OptionsCounter;  ;
        input.placeholder = `${t('Feedback Setting.Enter Option Text')}`;
       var divMcqOptions = document.getElementById('mcqOptions'); 
        divMcqOptions.appendChild(input); 
        var inputSpanDelete = document.createElement('span');
        inputSpanDelete.tooltip="Delete";
        inputSpanDelete.setAttribute("class","option_del");
        inputSpanDelete.onclick =this.DeleteMcqOption;
        inputSpanDelete.id='mcqOptionDel_'+OptionsCounter;
        var inputIDelete = document.createElement('i');
        inputIDelete.className="fa fa-lg fa-trash";
        inputIDelete.ariaHidden="true";
        inputSpanDelete.appendChild(inputIDelete);
        divMcqOptions.appendChild(inputSpanDelete); 
        // var mybr = document.createElement('br');
        // divMcqOptions.appendChild(mybr);
    }
    DeleteMcqOption(e){
        var divMcqOptions = document.getElementById('mcqOptions');
        var elementId=(e.target.parentElement.id).split('_');
        var inputName="mcqOptionText"+parseInt(elementId[1]);
        var elementInput = document.getElementById(inputName);
        var elementDel = document.getElementById(e.target.parentElement.id);
        divMcqOptions.removeChild(elementInput); 
        divMcqOptions.removeChild(elementDel); 
    }
    DeleteEmojiOption(e){
        var elementId=(e.target.parentElement.id).split('_');
        let divId = 'emojiOptions_' + parseInt(elementId[1]);
        var divEmojiOptions = document.getElementById(divId);
        var emojiElement = document.getElementById('emoji_option');
        emojiElement.removeChild(divEmojiOptions);
    }
    createEmojiOptions(){
        const { t } = this.props;
        EmojiCounter=EmojiCounter+1; 
        var divEmojiOptions = document.createElement('div');
        divEmojiOptions.id="emojiOptions_"+EmojiCounter;
        var emojiElement = document.getElementById('emoji_option');
        emojiElement.appendChild(divEmojiOptions);
        var input = document.createElement('input');
        input.type = 'text';
        input.class="formControl1";
        input.id='emojiOptionText'+EmojiCounter;
        input.name = 'emojiOptionText'+EmojiCounter;
        input.title= 'emojiOptionText'+EmojiCounter;  ;
        input.placeholder = `${t('Feedback Setting.Enter Emoji Option Text')}`;
        divEmojiOptions.appendChild(input); 
        var emojiList=this.props.feedbackSettings.emojiImage;
        
        emojiList.forEach(this.apendNode); 
        var inputSpanDelete = document.createElement('span');
        inputSpanDelete.tooltip="Delete";
        inputSpanDelete.setAttribute("class","option_del");
        inputSpanDelete.onclick =this.DeleteEmojiOption;
        inputSpanDelete.id='emojiOptionDel_'+EmojiCounter;
        var inputIDelete = document.createElement('i');
        inputIDelete.className="fa fa-lg fa-trash";
        inputIDelete.ariaHidden="true";
        inputSpanDelete.appendChild(inputIDelete); 
        divEmojiOptions.appendChild(inputSpanDelete);
    }
    apendNode(item){
        var inputlbl ;
        inputlbl = document.createElement('label');
      inputlbl.key="EmojiImage"+item.Id;
      inputlbl.className="checkbox-inline";

 var  inputRad = document.createElement('input');
 inputRad.type = 'radio';
 inputRad.id='EmojiImageCB'+EmojiCounter;
 inputRad.name = 'EmojiImage'+EmojiCounter;  
 inputRad.key=item.Id;
 inputRad.value=item.Id;

 var  inputImg = document.createElement('img');
 inputImg.src=baseUrl+item.EmojiImage;
 inputImg.style.width="40px";
 inputImg.style.height="40px";

 inputlbl.appendChild(inputRad);
 inputlbl.appendChild(inputImg);
 var divEmojiOptions = document.getElementById('emojiOptions_' + EmojiCounter);
 divEmojiOptions.appendChild(inputlbl); 
    }
 
    render() {  
        const { t } = this.props;
        let  optionQuestionType,optionEmojiImage, optionFeedbackType;
        let QuestionTypeVal = this.props.feedbackSettings.questionType; 
        let feedbackTypeVal = this.props.feedbackSettings.FeedbackTypesList; 

        if(QuestionTypeVal){
            optionQuestionType = QuestionTypeVal.map((QuestionTypeValue) =>
                <option value={QuestionTypeValue.QuestionTypeId} key={QuestionTypeValue.QuestionTypeId}>{QuestionTypeValue.QuestionTypes}</option>
            ); 
        }   
        if(feedbackTypeVal){
            optionFeedbackType = feedbackTypeVal.map((item) =>
                <option value={item.FeedbackTypeId} key={item.FeedbackTypeId}>{item.FeedbackType}</option>
            ); 
        }
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Feedback Setting.Add Feedback Question Details')}</h2>
                </div>
            
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                
                                    <form >  
                                    <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-2 radio-label">
                                            <label htmlFor="NotifType" className="form-label">{t('Feedback Setting.Feedback types')} </label>
                                        </div> 
                                        <div className="col-md-9">
                                            <div className="input-group">   
                                            <span className="input-group-addon">
                                                <i className="fa fa-question" aria-hidden="true"></i>
                                            </span>
                                                <select  id="FeedbackTypeId"  className="form-control1"
                                                    onChange={this.handleInput} 
                                                    value = {this.state.feedbackSettings.FeedbackTypeId}
                                                    placeholder="Select" 
                                                    ref="FeedbackTypeId"
                                                    name='FeedbackTypeId'
                                                >
                                                    {optionFeedbackType}
                                                </select>
                                            </div> 
                                        </div>
                                    </div> 
                                </div>
                                    <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label htmlFor="QuestionText" className="form-label">{t('Feedback Setting.Feedback Question Text')}</label>
                                                </div>
                                                <div className="col-md-9">
                                                    <InputWithExtra 
                                                    type={'text'}
                                                    title= {'QuestionText'} 
                                                    name= {'QuestionText'}
                                                    value={this.state.feedbackSettings.QuestionText} 
                                                    placeholder = {t('Feedback Setting.Enter Feedback Question')}
                                                    onChange = {this.handleInput} 
                                                    />  
                                                    {this.validator.message(`${t('Feedback Setting.Question Text')}`, this.state.feedbackSettings.QuestionText, 'required|min:3')}
                                                </div>
                                            </div>
                                        </div> 
                                    <div className="form-group">
                                    <div className="row">
                                    <div className="col-md-2 radio-label">
                                                    <label htmlFor="NotifType" className="form-label">{t('Feedback Setting.Question Type')} </label>
                                                </div> 
                                <div className="col-md-9">
                                    <div className="input-group">   
                                       <span className="input-group-addon">
                                         <i className="fa fa-question" aria-hidden="true"></i>
                                      </span>
                                        <select  id="questionTypeDD"  className="form-control1"
                                            onChange={this.handleInput} 
                                            value = {this.state.feedbackSettings.QuestionTypeId}
                                            placeholder="Select" 
                                            ref="QuestionTypeId"
                                            name='QuestionTypeId'
                                        >
                                            {optionQuestionType}
                                        </select>
                                    </div> 
                                 </div></div> 
                            </div> 
                            {(this.state.feedbackSettings.QuestionTypeId == "2")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Feedback Setting.Add Options')} </label> 
                                                </div>
                                                <div className="col-md-8">     
                                                       <div id="mcqOptions">
                                                       <input type="text"  title= "mcqOptionText1"  id='mcqOptionText1'
                                                            name= "mcqOptionText1" placeholder = {t('Feedback Setting.Enter Option Text')} className="formControl1 option_text" />
                                                        {/* <span id="mcqOptionDel_1" onClick={this.DeleteMcqOption} className="option_del"><i class="fa fa-lg fa-trash" aria-hidden="true"></i></span> */}
                                                    {/* <br/> */}
                                                        </div>
                                                        <button type="button" className="btn btn-primary general-btn" id="addMoreMcqOption" onClick={() => { this.createOptionsTextbox() }}>{t('Feedback Setting.Add Options')}</button>
                                                 </div>
                                                </div>
                                            </div>:''}  
                                            {(this.state.feedbackSettings.QuestionTypeId == "3")?
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-2 radio-label">
                                                    <label  className="form-label">{t('Feedback Setting.Add Emoji')} </label> 
                                                </div>
                                                <div className="col-md-8" id="emoji_option">     
                                                       <div id="emojiOptions_1">
                                                       <input type="text"  title= "emojiOptionText1"  className="formControl1" id='emojiOptionText1'
                                                    name= "emojiOptionText1" 
                                                    placeholder = {t('Feedback Setting.Enter Emoji Option Text')} 
                                               /> 
                                 
                               {
                                this.props.feedbackSettings.emojiImage.map(item => 
                                       
                                                                <label key={"EmojiImage"+item.Id} className="checkbox-inline">
                                                                    <input 
                                                                      id = "EmojiImageCB1"
                                                                      name="EmojiImage1" 
                                                                      value={item.Id}
                                                                      key={item.Id} 
                                                                      type="radio" /><img src={baseUrl+item.EmojiImage} style={{width:"40px",height:"40px"}} /> 
                                                                  </label> 
                                         
                                ) 
                                                                      } 
                                        {/* <span id="emojiOptionDel_1" onClick={this.DeleteEmojiOption} className="option_del"><i class="fa fa-lg fa-trash" aria-hidden="true"></i></span> */}
                                            <br/>  </div>
                                                 </div>
                                                 <button type="button" className="btn btn-primary general-btn" id="addMoreEmojiOptionText" onClick={() => { this.createEmojiOptions() }}>{t('Feedback Setting.Add Options')}</button>
                                                </div>
                                            </div>:''}  
                                            <div className="form-group"> 
                                                <div className="col-sm-offset-5 col-sm-6">      
                                                <p className="butn-center">
                                                <button type="button" className="btn btn-primary general-btn" 
                                                    onClick={() => { this.insertQuestionDetailsSettings() }}
                                                    disabled={this.state.isLoader}
                                                >{t('Alarm Setting.Save')}</button>
                                                {
                                                    this.state.isLoader?  
                                                    <img src={loader} width="30" alt="" />:''
                                                }
                                                </p>
                                                </div>
                                            </div>
                                    </form>  
                            </div>
                        </div>
                    </div>     
                   {/* <ToastContainer />  */}
                        
                </div>  
            </div>
        )
    }
}

export default withNamespaces()(withRouter(FeedbackSettingAddComponent));